var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0.10498C1.9809 0.10498 0.75 1.33093 0.75 2.84948C0.75 5.47518 3.5 8.89948 3.5 8.89948C3.5 8.89948 6.25 5.47463 6.25 2.84948C6.25 1.33148 5.0191 0.10498 3.5 0.10498ZM3.5 4.36803C3.10615 4.36803 2.72844 4.21158 2.44995 3.93308C2.17146 3.65459 2.015 3.27688 2.015 2.88303C2.015 2.48918 2.17146 2.11147 2.44995 1.83298C2.72844 1.55449 3.10615 1.39803 3.5 1.39803C3.89385 1.39803 4.27156 1.55449 4.55005 1.83298C4.82855 2.11147 4.985 2.48918 4.985 2.88303C4.985 3.27688 4.82855 3.65459 4.55005 3.93308C4.27156 4.21158 3.89385 4.36803 3.5 4.36803Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.95a653a83f22dee841b13d745ab21344.svg";
export { ForwardRef as ReactComponent };